import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=db6a8884&"
import script from "./NotificationModal.vue?vue&type=script&lang=js&"
export * from "./NotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=db6a8884&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports